<template>
  <div>
    <div class="page-title underline mb-2"><mdb-icon  icon="comments" /> 정기 상담</div>
    <mdb-row v-if="training && training._id">
      <mdb-col md="2">
        <!-- 학생 목록 -->
        <student-list :training="training._id" v-model="student"/>
      </mdb-col>
      <mdb-col md="10">
        <div class="clearfix">
          <div class="float-left">
            <!-- 상담목록 -->
            <div class="orange-text bolder p-1"  v-if="counsel && counsel.counsels.length == 0">
              <mdb-icon icon="info-circle" />  상담 이력이 없습니다.
            </div>
            <div v-for="(c, ix) in studentCounsels" :key="c._id" @click="cIndex=ix" :class="activeClass(ix)">
              <mdb-icon far icon="comments" /> {{ix + 1}}차 정기 상담
              <span class="clock ml-3"><mdb-icon icon="clock" /> {{$strDate(c.regDate)}}</span>
            </div>
          </div>
          <!-- 버튼 목록 -->
          <div v-if="student" class="float-right text-right">
            <add-btn-sm @click="onAddCounsel">추가</add-btn-sm>
          </div>
        </div>
        <hr v-if="studentCounsels.length"/>
        <!-- 상담 상세보기 -->
        <counsel v-if="counsel && cIndex !== -1 && counsel.counsels.length > 0"
          :counsel="counsel.counsels[cIndex]" :seq="cIndex+1" :counseler="counseler" :student="student.name"
          @save="onSave" @delete="onDelete"/>
      </mdb-col>
    </mdb-row>
  </div>
</template>
<script>
import RegularCounselPage from '@/views/staffCommon/RegularCounselPage.vue';
import RegularCounsel from '@/models/RegularCounsel'
import Counsel from '../../../components/counsel/Counsel.vue';
import StudentList from '../../../components/common/StudentList.vue';
import { mapState } from 'vuex';
export default {
  name: 'StaffRegularCounselPage',
  components: { StudentList, Counsel },
  data: () => ({
    student: null, // 학생 리스트
    counsels: {}, // 학생별 상담 맵
    cIndex: 0, // 회차 선택 인덱스,
    counsel: undefined
  }),
  computed: {
    ...mapState('auth', ['profile']),
    ...mapState('training', ['training']),
    counseler () {
      if (!this.profile) return {}
      return { _id: this.profile._id, name: this.profile.name }
    },
    studentCounsels () {
      return this.student ? this.counsels[this.student._id].counsels : []
    }
  },
  methods: {
    activeClass (ix) {
      return ix === this.cIndex ? 'bolder' : 'pointer'
    },
    async load () {
      if (!this.training._id) return
      this.counsels = await RegularCounsel.list({ training: this.training._id })
      this.counsels = this.counsels.reduce((acc, c) => {
        acc[c.student] = c
        return acc
      }, {})
    },
    // 상담 추가
    onAddCounsel () {
      this.counsel.counsels.push({ counseler: this.counseler, regDate: new Date() })
      this.cIndex = this.counsel.counsels.length - 1
    },
    async onSave () {
      if (!confirm('저장할까요')) return
      const counsel = await this.counsel.save()
      if (!this.counsel._id) { // 첫 상담이면 교체
        this.counsels[this.student._id] = counsel
      }
    },
    async onDelete () {
      if (!confirm('삭제할까요')) return
      this.counsel.counsels.splice(this.cIndex, 1)
      await this.counsel.save()
      this.cIndex = -1
    }
  },
  watch: {
    training () { this.load() },
    student () {
      // 항목이 없으면 추가
      if (!this.counsels[this.student._id]) {
        this.counsels[this.student._id] = RegularCounsel.create(this.training._id, this.student._id, this.counseler)
        this.cIndex = -1
      } else {
        this.cIndex = 0
      }
      this.counsel = this.counsels[this.student._id]
    }
  },
  created () {
    this.load()
  }
}
</script>
